module.exports = __webpack_public_path__ + "static/media/inicioChat.51e63816.png";